export default __webpack_public_path__ + "static/media/Lutzen_Halftone.8e4a012e.png";